import autobind from 'core-decorators/lib/autobind';
import { intlShape } from 'react-intl';
import classnames from 'classnames';

import { WixConnect } from 'shared/utils/wix-connect';

import Icon from 'shared/components/icon/icon';
import { LinkButton } from 'shared/components/button/button';

import classicStyles from './classic-search-bar.styl';
import stripStyles from './strip-search-bar.styl';

import translations from './translations';


class SearchBar extends React.Component {

  static propTypes = {
    onChange: React.PropTypes.func,
    onSearch: React.PropTypes.func,
    onClose: React.PropTypes.func,
    onFocus: React.PropTypes.func,
    onBlur: React.PropTypes.func,
    biEvent: React.PropTypes.func,
    className: React.PropTypes.string,
    value: React.PropTypes.string,
    intl: intlShape,
  };

  static defaultProps = {
    value: '',
    onChange: _.noop,
    onSearch: _.noop,
    onClose: _.noop,
    onFocus: _.noop,
    onBlur: _.noop,
    onKeyPress: _.noop,
  };

  constructor(props) {
    super(props);

    this.state = {
      currentValue: props.value,
      focused: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({ currentValue: nextProps.value });
    }
  }

  @autobind
  updateValue() {
    const { value } = this.input;
    this.props.onChange(value);
    this.setState({ currentValue: value });
  }

  @autobind
  searchOnEnter(event) {
    const { keyCode } = event.nativeEvent;
    const { value } = this.input;

    // check if Enter
    if (keyCode === 13) {
      this.sendSearchBI(value);
      this.permitSearch();
    }
  }

  sendSearchBI(searchQuery) {
    if (searchQuery !== '') {
      this.props.biEvent('widget.search.clicked');
    }
  }

  setFocused(focused) {
    // Don`t hide if click outside with new value passed to props
    setTimeout(() => this.setState({ focused }), 0);
  }

  @autobind
  permitSearch() {
    const { onSearch } = this.props;
    const { value } = this.input;
    this.setFocused(true);

    onSearch(value);
  }

  @autobind
  closeSearch() {
    this.input.value = '';
    this.setState({
      currentValue: '',
      focused: false,
    });
    this.props.onClose('');
  }

  @autobind
  handleFocus(event) {
    this.props.onFocus(event);
    this.setFocused(true);
  }

  @autobind
  handleBlur(event) {
    this.props.onBlur(event);
    this.setFocused(false);
  }

  get styleNames() {
    const { currentValue, focused } = this.state;
    const { value } = this.props;

    return classnames('container', {
      'has-value': currentValue,
      'has-submitted-value': value,
      changed: value !== currentValue,
      focused,
    });
  }

  render() {
    const { intl: { formatMessage }, className } = this.props;
    const placeholder = formatMessage(translations.searchVideo);

    return (
      <div className={className}
           styleName={this.styleNames}>
        <div styleName="background-text">
          {placeholder}
        </div>
        <input type="text"
               styleName="input search-bar"
               className="qa-search-bar-input"
               value={this.state.currentValue}
               onKeyPress={this.searchOnEnter}
               onFocus={this.handleFocus}
               onBlur={this.handleBlur}
               onChange={this.updateValue}
               ref={node => (this.input = node)}
               placeholder={placeholder} />
        <Icon styleName="search-icon"
              name="search-bar" />
        <LinkButton styleName="close-search"
                    onClick={this.closeSearch}>
          <Icon name="clear-search" />
        </LinkButton>
        <LinkButton styleName="permit-search"
                    onClick={this.permitSearch}>
          <Icon name="permit-search" />
        </LinkButton>
      </div>
    );
  }
}


export const ClassicSearchBar = WixConnect(classicStyles)(SearchBar);
export const StripSearchBar = WixConnect(stripStyles)(SearchBar);



// WEBPACK FOOTER //
// ./src/widget/components/search-bar/search-bar.js